export default __webpack_public_path__ + "static/media/PowellCatLocation-17.817b82a2.jpg";